export default __webpack_public_path__ + "static/media/koleos-colour-6.351b9e27.jpg";